import React, { useState, useEffect, useRef } from 'react';
import './nav.scss';
import {requestDemoEmail} from '../../utils/requestDemoEmail';
import logo from '../../assets/logo/fs_blue_logo.png';
import MobileNav from '../../assets/common/mobile_nav.png';
import {
    BrowserRouter as Router,
    Routes,
    Route, 
    NavLink,
    useLocation
} from 'react-router-dom';
import Main from '../main/main';
import Solutions from '../solutions/solutions';
import HowItWorks from '../howItWorks/howItWorks';
import Mobility from '../mobility/mobility';
import SupplyChain from '../supplyChain/supplyChain';
import Preparedness from '../preparedness/preparedness';
import FinancialNetwork from '../financialNetwork/financialNetwork';
import ContestedLogistics from '../contestedLogistics/contestedLogistics';
import NotFound from '../notFound/notFound';

const Nav = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const mobileMenuButtonRef = useRef(null);
    const mobileMenuRef = useRef(null);
    const mobileMenuCloseRef = useRef(null);
    let location = useLocation();

    const handleResize = () => {
        if (window.innerWidth > 840) {
            setIsMobileMenuOpen(false);
        }
    }

    useEffect(() => {
        setIsMobileMenuOpen(false);
    },[location])

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    },[])

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        mobileMenuButtonRef.current?.focus();
    }

    useEffect(() => {
        if (!isMobileMenuOpen) {
            return;
        }

        mobileMenuCloseRef.current?.focus();

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeMobileMenu();
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            const focusableElements = mobileMenuRef.current?.querySelectorAll(
                'a[href], button:not([disabled])'
            );

            if (!focusableElements?.length) {
                return;
            }

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isMobileMenuOpen])

    const handleMobileNav = () => {
        if (isMobileMenuOpen) {
            closeMobileMenu();
            return;
        }

        setIsMobileMenuOpen(true);
    }

    const activeSolutions = (name) => {
        if (location.pathname == name) {
            return 'solutionSection active'
        } 
        return 'solutionSection'
    }

    return (
        <>
        <header className="header">
                <NavLink to="/">
                    <span className="header_logo">
                        <img src={logo} alt=""></img>
                        <span className="header_logo_text duborics">FUTURESCAPE</span>
                    </span>
                </NavLink>
                <nav className="header_nav">
                    <NavLink to="./howItWorks" className="nav_section">HOW IT WORKS</NavLink>
                    <div className="solutions_container">
                        <NavLink to="/solutions" id="solutions" className="nav_section">SOLUTIONS</NavLink>
                        <div id="solutionsDropdown" className="box-shadow">
                            <span className={activeSolutions('/mobility')} key="mobility"><NavLink to="./mobility">Mobility</NavLink></span>
                            <span className={activeSolutions('/supplyChain')} key="supplyChain"><NavLink to="./supplyChain">Supply Chain</NavLink></span>
                            <span className={activeSolutions('/preparedness')} key="preparedness"><NavLink to="./preparedness">Preparedness</NavLink></span>
                            <span className={activeSolutions('/financialNetworks')} key="financialNetwork"><NavLink to="./financialNetworks">Financial Networks</NavLink></span>
                            <span className={activeSolutions('/contestedLogistics')} key="contestedLogistics"><NavLink to="./contestedLogistics">Contested Logistics</NavLink></span>
                        </div>
                    </div>
                    <div>
                        <button className="demo_btn" onClick={requestDemoEmail}>REQUEST DEMO</button>
                    </div>
                </nav>


                {/* MOBILE NAVIGATION */}
                <button
                    ref={mobileMenuButtonRef}
                    type="button"
                    id="mobile_nav_btn"
                    className="mobile_nav"
                    aria-label={isMobileMenuOpen ? 'Close mobile navigation menu' : 'Open mobile navigation menu'}
                    aria-expanded={isMobileMenuOpen}
                    aria-controls="mobile-menu"
                    onClick={handleMobileNav}
                >
                    <img src={MobileNav} alt=""></img>
                </button>
                <div
                    className={`overlay ${isMobileMenuOpen ? 'active' : ''}`}
                    aria-hidden="true"
                    onClick={closeMobileMenu}
                ></div>
                <div
                    id="mobile-menu"
                    ref={mobileMenuRef}
                    className={`mobile_nav_content ${isMobileMenuOpen ? 'slideIn' : ''}`}
                    aria-hidden={!isMobileMenuOpen}
                    hidden={!isMobileMenuOpen}
                >
                    <div className="wrapper">
                        <button
                            ref={mobileMenuCloseRef}
                            type="button"
                            className="mobile_nav_close"
                            aria-label="Close mobile navigation menu"
                            onClick={closeMobileMenu}
                        >
                            &times;
                        </button>
                        <span className="duborics header_1">MENU</span>
                        <nav
                            className="menu_content"
                            aria-label="Mobile navigation"
                            onClick={closeMobileMenu}
                        >
                            <ul>
                                <li><NavLink to="/">MAIN</NavLink></li>
                                <li><NavLink to="./howItWorks">HOW IT WORKS</NavLink></li>
                                <li><NavLink to="./solutions">SOLUTIONS</NavLink></li>
                                <li><NavLink to="./mobility">Mobility</NavLink></li>
                                <li><NavLink to="./supplyChain">Supply Chain</NavLink></li>
                                <li><NavLink to="./preparedness">Preparedness</NavLink></li>
                                <li><NavLink to="./financialNetworks">Financial Networks</NavLink></li>
                                <li><NavLink to="./contestedLogistics">Contested Logistics</NavLink></li>
                                <li>
                                    <button className="text" type="button" onClick={requestDemoEmail}>
                                        REQUEST DEMO
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
        </header>

        <Routes>
            <Route path="/home" element={<Main />}></Route>
            <Route path="/" element={<Main />}></Route>
            <Route path="/howItWorks" element={<HowItWorks />}></Route>
            <Route path="/solutions" element={<Solutions />}></Route>
            <Route path="/mobility" element={<Mobility />}></Route>
            <Route path="/supplyChain" element={<SupplyChain />}></Route>
            <Route path="/financialNetworks" element={<FinancialNetwork />}></Route>
            <Route path="/contestedLogistics" element={<ContestedLogistics />}></Route>
            <Route path="/preparedness" element={<Preparedness />}></Route>
            <Route path="*" element={<NotFound />}></Route>
        </Routes>
        </>
    )
}

export default Nav;